import { CONSTANTS } from '@sohohouse/platform-resources'
import defaultStateFactory from './state'

export const RESULTS_PER_PAGE = 12

export const POLL_MAX_TIME = 1000 * 30 // 30 seconds
export const POLL_INTERVAL = 2000

export const SEARCHES = {
  FEATURED: {
    perPage: 3,
    filter: {
      featured: true
    }
  },

  HISTORY: {
    perPage: 4,
    recommend: CONSTANTS.RECOMMENDED_EVENTS.HISTORY
  },

  ALL: {
    perPage: RESULTS_PER_PAGE
  },

  INDUCTION: {
    perPage: 100,
    filter: {
      type: CONSTANTS.EVENT_TYPES.INDUCTION
    }
  }
}

export const defaultState = defaultStateFactory()

export const sharedFilters = ['fromDate', 'toDate', 'houses']
export const uniqueFilters = ['categories']
